var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCalendar1 = function SvgIconCalendar1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 30.5,
    height: 30.5,
    rx: 15.25,
    stroke: "#4E6DF5",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 9a.5.5 0 0 0-.5.5V11h-1a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V12a1 1 0 0 0-1-1h-1V9.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5V11h-6V9.5a.5.5 0 0 0-.5-.5h-1Zm9.5 7H11v4.5a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5V16Z",
    fill: "#4E6DF5"
  })));
};
export default SvgIconCalendar1;